import React, { useEffect } from "react"
import s from "./Home.module.scss"

import MainLayout from "layouts/Main"
import Header from "components/Header"
import HomeHero from "components/HomeHero"
import HomeFeature from "components/HomeFeature"
import Footer from "components/Footer"
import TagManager from "react-gtm-module"

import FeatureKia from "assets/images/dogmented/kia.jpg"
import FeaturePetfinder from "assets/images/dogmented/petfinder.jpg"

const Home = ({ children }) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        pagePath: "/",
        pageTitle: "Home",
      },
    })
  }, [])
  return (
    <MainLayout>
      <div className={s.Home}>
        <Header />
        <HomeHero />
        <HomeFeature
          cta="Learn More"
          link="https://www.kia.com/us/en/ev6"
          img={FeatureKia}
          alt="Kia EV6"
          gtmClass="exploreKia"
        >
          <h2>Live Fully Charged</h2>
          <p>Introducing the all-electric Kia EV6.</p>
        </HomeFeature>
        <HomeFeature
          cta="Adopt Today"
          link="https://petfinderfoundation.com/kia"
          img={FeaturePetfinder}
          alt="Pet Finder"
          gtmClass="adopt"
        >
          <p>
            Through the Kia Pet Adoption Grants, we’re proud to support the
            Petfinder Foundation. Will you give a shelter dog a forever home?
          </p>
        </HomeFeature>
        <Footer />
      </div>
    </MainLayout>
  )
}

export default Home
